"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpUserProfileDropdown: {
        logout: 'Log out',
        logoutAriaLabel: 'Logged in as {{fullName}}, show options',
    },
};
